import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.7;

    display: inline-block;

    padding: .625rem 1.6rem;

    -webkit-user-select: none;
    -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;

    border: .0625rem solid transparent;
    border-radius: .25rem;
    color: #fff;
    border-color: #1E44C1;
    background-color: #1E44C1;
    box-shadow: none;
    cursor: pointer;
`;
const UploadButton = props => {
  const hiddenFileInput = React.useRef(null);
  
  const handleClick = event => {
    hiddenFileInput.current.click();
  };
  const handleChange = event => {
    const fileUploaded = event.target.files[0];
    props.handleFile(fileUploaded);
  };
  return (
    <>
      <Button onClick={handleClick}>
        {props.title}
      </Button>
      <input type="file"
             ref={hiddenFileInput}
             onChange={handleChange}
             style={{display:'none'}} 
      /> 
    </>
  );
};
export default UploadButton;